import { useState, useEffect } from 'react';
import { getLanguage } from '../../firebase';
import './ScrollToTopButton.css';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [language, setLanguage] = useState(getLanguage());

  const handleScroll = () => {
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    setIsVisible(scrolled > 100);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
      });
    }, 400);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    const handleLanguageChange = () => {
      setLanguage(getLanguage());
    };
    window.addEventListener('languageChanged', handleLanguageChange);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
    <button
      className={`scroll-to-top ${isVisible ? 'visible' : ''} ${language === 'ar' ? 'rtl' : 'ltr'}`}
      onClick={scrollToTop}
    >
      <svg
        className="scroll-to-top-icon"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="24" cy="24" r="24" fill="#059669" />
        <path
          d="M24 14 L24 34 M16 22 L24 14 L32 22"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;
